import React from 'react';
import { Text } from '@react-three/drei';
import { userAvatarMaterial, userAvatarColor } from '../SharedMeshes/SharedMeshes';

const TextMesh: React.FC<{ text: string, positionY: number, rotationY: number }> = ({ text, positionY, rotationY }) => {
  return (
    <mesh position-y={positionY} rotation-y={rotationY}>
      {userAvatarMaterial}
      <Text fontSize={0.67} color={userAvatarColor}>
        {text}
      </Text>

    </mesh>
  );
};

export default TextMesh;